export default {
	isLoading: state => {
		return state.isloading;
	},
	lista: state => {
		return state.empresas || [];
	},
	seleccionada: state => {
		return state.selected;
	},
	razon_social: state => {
		return !!state.selected? state.selected.razon_social: '-';
	},
	rut: state => {
		let selected = state.selected;
		if( !!selected )
			return !!selected? `${selected.rut}${selected.dv}`: false;
		else
			return '-';
	},
	selectedRut: state => {
		let selected = state.selected;
		if( !!selected )
			return !!selected? selected.rut: null;
		else
			return null;
	}
}